import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import LeaveRequestPage from './LeaveRequestPage';

// ============================================================================
// PHASE 1: NAVIGATION WRAPPER COMPONENT
// ============================================================================

interface LeaveRequestPageWrapperProps extends WithTranslation {
  // Props will be passed through to LeaveRequestPage
}

const LeaveRequestPageWrapper: React.FC<LeaveRequestPageWrapperProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Phase 1: Extract navigation parameters from query string (prioritized) or location state
  const searchParams = new URLSearchParams(location.search);
  const state = location.state as any;
  
  // Phase 1: Navigation parameters - prioritize query string for better web parameter management
  const leave_id = searchParams.get('leave_id') || state?.leave_id || '';
  const children_id = searchParams.get('children_id') || state?.children_id || '';
  const categoryId = searchParams.get('categoryId') || state?.categoryId || '';
  const timeslotId = searchParams.get('timeslotId') || state?.timeslotId || '';
  const childId = searchParams.get('childId') || state?.childId || '';
  const code = searchParams.get('code') || state?.code || '';
  
  // Phase 1: Navigation functions - use query strings for better web parameter management
  const handleNavigate = (path: string, params?: any) => {
    if (params) {
      // Convert params to query string for better web parameter management
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const queryString = queryParams.toString();
      navigate(queryString ? `${path}?${queryString}` : path);
    } else {
      navigate(path);
    }
  };
  
  const handleGoBack = () => {
    navigate(-1);
  };
  
  // Phase 1: Debug logging for development
  if (process.env.NODE_ENV === 'development') {
    console.log('LeaveRequestPageWrapper - Navigation params:', {
      leave_id,
      children_id,
      categoryId,
      timeslotId,
      childId,
      code,
      locationState: state,
      searchParams: Object.fromEntries(searchParams.entries())
    });
  }
  
  return (
    <LeaveRequestPage
      {...props}
      // Phase 1: Pass navigation props
      leave_id={leave_id}
      children_id={children_id}
      categoryId={categoryId}
      timeslotId={timeslotId}
      childId={childId}
      code={code}
      navigate={handleNavigate}
      goBack={handleGoBack}
    />
  );
};

export default withTranslation()(LeaveRequestPageWrapper);